import React, { useState, useEffect, useRef } from "react";
import "../styles/sirappu.css";

const ImageSlider = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const intervalRef = useRef(null);

  const nextSlide = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const startInterval = () => {
    intervalRef.current = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);
  };

  const clearCurrentInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    startInterval();
    return () => clearCurrentInterval();
  }, [images.length]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    clearCurrentInterval();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    startInterval();
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
    if (!isFullscreen) {
      clearCurrentInterval();
    } else {
      startInterval();
    }
  };

  const handleKeyDown = (e) => {
    if (isFullscreen) {
      if (e.key === 'Escape') {
        toggleFullscreen();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        prevSlide();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isFullscreen, currentImageIndex]);

  return (
    <>
      <div
        className="slider-containersira"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className={`slidesira ${index === currentImageIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${image})` }}
            onClick={toggleFullscreen}
          />
        ))}
        <button className="slider-buttonsira prev" onClick={prevSlide}>
          &#10094;
        </button>
        <button className="slider-buttonsira next" onClick={nextSlide}>
          &#10095;
        </button>
        <div className="slide-indicators">
          {images.map((_, index) => (
            <span
              key={index}
              className={`indicator ${
                index === currentImageIndex ? "active" : ""
              }`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </div>

      {isFullscreen && (
        <div className="fullscreen-overlay" onClick={toggleFullscreen}>
          <div className="fullscreen-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-fullscreen" onClick={toggleFullscreen}>
              &times;
            </button>
            <img 
              src={images[currentImageIndex]} 
              alt={`Slide ${currentImageIndex + 1}`} 
              className="fullscreen-image"
            />
            <button className="fullscreen-button prev" onClick={prevSlide}>
              &#10094;
            </button>
            <button className="fullscreen-button next" onClick={nextSlide}>
              &#10095;
            </button>
            <div className="fullscreen-indicators">
              {images.map((_, index) => (
                <span
                  key={index}
                  className={`fullscreen-indicator ${
                    index === currentImageIndex ? "active" : ""
                  }`}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const TabContent = ({ tab }) => {
  const [tabData, setTabData] = useState("tab1");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/home.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        // Make sure data.portfolioData exists before setting it
        if (data.tabData) {
          setTabData(data.tabData);
        } else {
          throw new Error("portfolioData not found in response");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const currentTabData = tabData[tab];

  return (
    <div className="tab-contentsira">
      <div className="content-wrapper">
        <ImageSlider images={currentTabData.images} />
        <h2 className="tab-title">{currentTabData.title}</h2>
        <div className="description-container">
          <p className="description-text">{currentTabData.description}</p>
          {currentTabData.description1 && (
            <p className="description-text">{currentTabData.description1}</p>
          )}
        </div>
      </div>
    </div>
  );
};

const Sirappunigal = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <div className="appsira">
      <h1 className="page-title">சிறப்பு நிகழ்வுகள்</h1>
      <div className="tabssira">
        <button
          className={`tab-buttonsira ${activeTab === "tab1" ? "active" : ""}`}
          onClick={() => setActiveTab("tab1")}
        >
          ஓவிய போட்டி
        </button>
        <button
          className={`tab-buttonsira ${activeTab === "tab2" ? "active" : ""}`}
          onClick={() => setActiveTab("tab2")}
        >
          தேசிய அறிவியல் தினவிழா
        </button>
        <button
          className={`tab-buttonsira ${activeTab === "tab3" ? "active" : ""}`}
          onClick={() => setActiveTab("tab3")}
        >
          உலகப் புத்தக தினவிழா
        </button>
      </div>
      <TabContent tab={activeTab} />
    </div>
  );
};
export default Sirappunigal;




// import React, { useState, useEffect, useRef } from "react";
// import "../styles/sirappu.css";

// const ImageSlider = ({ images }) => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [isHovered, setIsHovered] = useState(false);
//   const intervalRef = useRef(null);

//   const nextSlide = () => {
//     setCurrentImageIndex((prevIndex) =>
//       prevIndex === images.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   const prevSlide = () => {
//     setCurrentImageIndex((prevIndex) =>
//       prevIndex === 0 ? images.length - 1 : prevIndex - 1
//     );
//   };

//   const startInterval = () => {
//     intervalRef.current = setInterval(() => {
//       setCurrentImageIndex((prevIndex) =>
//         prevIndex === images.length - 1 ? 0 : prevIndex + 1
//       );
//     }, 3000);
//   };

//   const clearCurrentInterval = () => {
//     if (intervalRef.current) {
//       clearInterval(intervalRef.current);
//     }
//   };

//   useEffect(() => {
//     startInterval();
//     return () => clearCurrentInterval();
//   }, [images.length]);

//   const handleMouseEnter = () => {
//     setIsHovered(true);
//     clearCurrentInterval();
//   };

//   const handleMouseLeave = () => {
//     setIsHovered(false);
//     startInterval();
//   };

//   return (
//     <div
//       className="slider-containersira"
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//     >
//       {images.map((image, index) => (
//         <div
//           key={index}
//           className={`slidesira ${index === currentImageIndex ? "active" : ""}`}
//           style={{ backgroundImage: `url(${image})` }}
//         />
//       ))}
//       <button className="slider-buttonsira prev" onClick={prevSlide}>
//         &#10094;
//       </button>
//       <button className="slider-buttonsira next" onClick={nextSlide}>
//         &#10095;
//       </button>
//       <div className="slide-indicators">
//         {images.map((_, index) => (
//           <span
//             key={index}
//             className={`indicator ${
//               index === currentImageIndex ? "active" : ""
//             }`}
//             onClick={() => setCurrentImageIndex(index)}
//           />
//         ))}
//       </div>
//       {/* {isHovered && (
//         <div className="pause-overlay">
//           <div className="pause-icon">⏸</div>
//         </div>
//       )} */}
//     </div>
//   );
// };

// const TabContent = ({ tab }) => {
//   const [tabData, setTabData] = useState("tab1");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch("/data/home.json");
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
//         const data = await response.json();
//         console.log(data);

//         // Make sure data.portfolioData exists before setting it
//         if (data.tabData) {
//           setTabData(data.tabData);
//         } else {
//           throw new Error("portfolioData not found in response");
//         }
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);
//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>Error: {error}</div>;

//   const currentTabData = tabData[tab];

//   return (
//     <div className="tab-contentsira">
//       <div className="content-wrapper">
//         <ImageSlider images={currentTabData.images} />
//         <h2 className="tab-title">{currentTabData.title}</h2>
//         <div className="description-container">
//           <p className="description-text">{currentTabData.description}</p>
//           {currentTabData.description1 && (
//             <p className="description-text">{currentTabData.description1}</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const Sirappunigal = () => {
//   const [activeTab, setActiveTab] = useState("tab1");

//   return (
//     <div className="appsira">
//       <h1 className="page-title">சிறப்பு நிகழ்வுகள்</h1>
//       <div className="tabssira">
//         <button
//           className={`tab-buttonsira ${activeTab === "tab1" ? "active" : ""}`}
//           onClick={() => setActiveTab("tab1")}
//         >
//           ஓவிய போட்டி
//         </button>
//         <button
//           className={`tab-buttonsira ${activeTab === "tab2" ? "active" : ""}`}
//           onClick={() => setActiveTab("tab2")}
//         >
//           தேசிய அறிவியல் தினவிழா
//         </button>
//         <button
//           className={`tab-buttonsira ${activeTab === "tab3" ? "active" : ""}`}
//           onClick={() => setActiveTab("tab3")}
//         >
//           உலகப் புத்தக தினவிழா
//         </button>
//       </div>

//       <TabContent tab={activeTab} />
//     </div>
//   );
// };

// export default Sirappunigal;
